var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgPhone = function SvgPhone(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1170_245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5587 10.2194C11.6366 10.1676 11.7262 10.136 11.8194 10.1275C11.9125 10.1191 12.0064 10.134 12.0923 10.1709L15.4083 11.6566C15.52 11.7044 15.6133 11.787 15.6741 11.8922C15.735 11.9974 15.7601 12.1195 15.7458 12.2402C15.6365 13.0566 15.2345 13.8055 14.6145 14.3476C13.9945 14.8898 13.1986 15.1883 12.375 15.1877C9.83887 15.1877 7.40661 14.1802 5.61329 12.3869C3.81998 10.5936 2.8125 8.16133 2.8125 5.6252C2.81187 4.80156 3.1104 4.00572 3.65257 3.3857C4.19474 2.76567 4.94364 2.36366 5.76 2.25442C5.88068 2.24008 6.00276 2.26521 6.10796 2.32605C6.21316 2.38689 6.29583 2.48017 6.34359 2.59192L7.8293 5.91067C7.8658 5.99591 7.88067 6.08885 7.87257 6.18122C7.86447 6.27359 7.83367 6.36253 7.78289 6.44012L6.28031 8.22676C6.22701 8.30719 6.1955 8.40007 6.18884 8.49632C6.18219 8.59257 6.20062 8.68891 6.24234 8.7759C6.82383 9.96629 8.0543 11.182 9.2482 11.7579C9.33566 11.7994 9.43243 11.8174 9.52898 11.8101C9.62553 11.8029 9.71851 11.7705 9.79875 11.7164L11.5587 10.2194Z",
    stroke: "#898989",
    strokeWidth: 0.84375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1170_245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Phone.8c9e032aa735cfa6cbfa8a61d7589045.svg";